import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-triangleup",
  "use": "icon-triangleup-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-triangleup\"><path fill=\"#ffffff\" d=\"M27.273 753.613l485.222-484.233 484.233 485.222z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol